import { Component, Input } from "@angular/core";
import { LinkTarget } from "src/app/types/link";

interface CTAInterface {
  cta_text: string;
  button_text: string;
  target: LinkTarget;
  hyperlink: string;
}

@Component({
  selector: "app-cta",
  templateUrl: "./cta.component.html",
  styleUrls: ["./cta.component.scss"],
})
export class CTAComponent {
  @Input() node: CTAInterface;

  constructor() {}
}
